import { useQuery } from 'react-query';

import { getCityList } from '../api/getCityList';
import { masterDataKeys, masterDataStaleTime } from '../api/queryKeys';

export const useCityList = (params, { enabled = true } = {}) => {
  const { data, isLoading, isError, refetch } = useQuery(
    masterDataKeys.cities(params),
    () => getCityList(params),
    {
      enabled,
      staleTime: masterDataStaleTime.BATCH,
      keepPreviousData: true,
    }
  );

  return { data, isLoading, isError, refetch };
};

export default useCityList;
